import React, {useEffect, useState} from "react";
import queryString from 'query-string'
import {useLocation} from "react-router-dom";
import gql from "../../api/gql";
import { Alert, Button, Spin } from 'antd';
import {Link} from "react-router-dom";

// Phải khớp amzReauthStatePrefix ở api-oopprint (graphql/amz_store_resolver.go).
const AMZ_REAUTH_STATE_PREFIX = "reauth";
const AMZ_STATE_KEY = "amz_oauth_state";

// Chỉ chuyển tiếp về domain của Amazon, tránh open redirect qua amazon_callback_uri.
const isAmazonUrl = (raw) => {
    try {
        const u = new URL(raw);
        // sellercentral.amazon.com, sellercentral-europe.amazon.com,
        // sellercentral.amazon.co.uk, sellercentral.amazon.com.mx, ...
        return u.protocol === "https:" &&
            /^sellercentral(-[a-z]+)?\.amazon\.(com|[a-z]{2}|co\.[a-z]{2}|com\.[a-z]{2})$/i.test(u.hostname);
    } catch (e) {
        return false;
    }
};

const readSavedState = () => {
    try {
        return localStorage.getItem(AMZ_STATE_KEY) || "";
    } catch (e) {
        return "";
    }
};

const clearSavedState = () => {
    try {
        localStorage.removeItem(AMZ_STATE_KEY);
    } catch (e) {}
};

// Trang này là cả Login URI lẫn Redirect URI của app trên Amazon:
// 1. Login URI: Amazon gửi amazon_callback_uri + amazon_state (chưa có
//    spapi_oauth_code). Gặp khi seller authorize lại từ Seller Central >
//    Manage Your Apps. Phải chuyển seller về amazon_callback_uri kèm
//    amazon_state + state để Amazon hiện màn hình xác nhận.
// 2. Redirect URI: có spapi_oauth_code -> gọi amzCreateStoreByOAuth. Backend
//    tự nhận ra store đã có theo seller_id và chỉ làm mới token.
const AmzAuthorizeAddStore = () => {
    let { search } = useLocation();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState(false);
    useEffect(() => {
        setLoading(true);
        const params = queryString.parse(search);

        if (params.amazon_callback_uri) {
            if (!isAmazonUrl(params.amazon_callback_uri) || !params.amazon_state) {
                setError("Invalid authorization request from Amazon.");
                setLoading(false);
                return;
            }
            const callback = new URL(params.amazon_callback_uri);
            callback.searchParams.set("amazon_state", params.amazon_state);
            callback.searchParams.set("state", readSavedState() || `${AMZ_REAUTH_STATE_PREFIX}__${params.selling_partner_id || ""}`);
            if (params.version) {
                callback.searchParams.set("version", params.version);
            }
            window.location = callback.toString();
            return;
        }

        const {selling_partner_id, spapi_oauth_code, state} = params;
        if (!spapi_oauth_code || !selling_partner_id || !state) {
            setError("Amazon did not return an authorization code. Please authorize again.");
            setLoading(false);
            return;
        }
        clearSavedState();
        const query = `mutation createStoreByOAth($auth_code: String!, $state: String!, $seller_id: String!) {
          amzCreateStoreByOAuth(auth_code: $auth_code, 
            state: $state,
          seller_id: $seller_id)
        }`;
        gql.request(query, {
            auth_code: spapi_oauth_code,
            state: state,
            seller_id: selling_partner_id,
        }).then(res => {
            setSuccess(true);
            setLoading(false);

            setTimeout(() => {
                window.location = "/sites"
            }, 3000)
        }).catch(error => {
            setError(error[0].message);
            setLoading(false);

            setTimeout(() => {
                window.location = "/sites"
            }, 3000)
        })
    }, []);
    return (
        <>
            {success &&
                <div>
                    <Alert
                        message="Success"
                        description={"Site connection successful!!"}
                        type="success"
                        showIcon
                    />
                    <Spin spinning={loading} tip="Loading...">
                        <div style={{
                            height: 70,
                            width: 70,
                            margin: "auto"
                        }}>

                        </div>
                    </Spin>
                </div>
            }
            {error !== "" &&
            <div style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center"
            }}>
                <Alert
                    message="Error"
                    description={error}
                    type="error"
                    showIcon
                />
                <Link to="/sites">
                    <Button style={{
                        marginTop: 5,
                        margin: "5px auto"
                    }} type="primary">Recreate</Button>
                </Link>
            </div>
            }
        </>
    )
}

export default AmzAuthorizeAddStore;